<template>
  <div class="container">
    <b-overlay :show="isLoading">
      <vue-pdf-embed
        :source="loadPdf()"
        @rendered="isLoading = false"
      />
    </b-overlay>
  </div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

import privacyPolicyEn from '@/assets/pdf/DIVEMA_CONCEPT_privacy-policy_en.pdf'
import privacyPolicyFr from '@/assets/pdf/DIVEMA_CONCEPT_privacy-policy_fr.pdf'

export default defineComponent({
  name: 'PrivacyPolicy',

  components: {
    VuePdfEmbed,
  },

  setup(_props, ctx) {
    const { $store } = ctx.root

    const privacyPolicy = {
      en: privacyPolicyEn,
      fr: privacyPolicyFr,
    }

    const isLoading = ref(true)

    const loadPdf = () => privacyPolicy[$store.state.appConfig.lang] || privacyPolicy.fr

    return {
      loadPdf,
      isLoading,
    }
  },
})
</script>
